import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch } from 'react-redux';

import { useTranslation } from 'app/lang';
import Footer from 'app/modules/Layout/Footer';
import { getBrandName } from 'app/packages/brand';
import ErrorBoundary from 'app/widgets/ErrorBoundary';

import { clearPrematchMatches } from './actions';
import { useMetaContent } from './hooks/useMetaContent';
import { PrematchDeferred } from './PrematchDeferred';

import dictionary from './PrematchPage.dictionary.json';

export const PrematchPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(clearPrematchMatches());
    };
  }, []);
  const { locationInfo, getMetaContent } = useMetaContent();
  const isAdvancedMeta = getBrandName() === 'komyob';

  const title = isAdvancedMeta ? getMetaContent(locationInfo, true) : t(dictionary.title);
  const description = isAdvancedMeta ? getMetaContent(locationInfo) : t(dictionary.description);

  return (
    <>
      <Helmet>
        <meta name="description"
              content={description} />

        <title>{title}</title>
      </Helmet>

      <ErrorBoundary>
        <PrematchDeferred />
        <Footer />
      </ErrorBoundary>
    </>
  );
};
